import { render, staticRenderFns } from "./criteria-modal.vue?vue&type=template&id=1f1a17a6&scoped=true&"
import script from "./criteria-modal.vue?vue&type=script&lang=ts&"
export * from "./criteria-modal.vue?vue&type=script&lang=ts&"
import style0 from "./criteria-modal.vue?vue&type=style&index=0&id=1f1a17a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a17a6",
  null
  
)

export default component.exports